import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { useCart, useCartTotal } from "../stores/cartStore"

const Cart = ({direction = 'horizontal', labelClass = 'text-gray-500', iconClass = 'text-gray-700', label = ''}) => {

    const {getItemsCount} = useCart()
    const [_, cartTotal] = useCartTotal()

    return (
        <Link to='/cart' className={`gap-4 flex-align item-hover ${direction === 'vertical' ? 'flex-column' : 'flex-row'}`}>
            <span className={`mt-6 text-2xl d-flex position-relative me-6 item-hover__text ${iconClass}`}>
                <i className='ph ph-shopping-cart-simple' />
                <span className='w-16 h-16 text-xs text-white flex-center rounded-circle bg-main-600 position-absolute top-n6 end-n4'>
                    {getItemsCount()}
                </span>
                {
                    getItemsCount() > 0 && (
                        <span className='px-2 text-white -tw-bottom-2 tw-w-max flex-center rounded-pill bg-main-600 position-absolute bottom-n6 end-n4' style={{fontSize: '0.625rem'}}>
                            {cartTotal}
                        </span>
                    )
                }
            </span>
            {
                label && (
                    <span className={`${labelClass} text-md item-hover__text d-none d-lg-flex`}>
                        {label}
                    </span>
                )
            }
        </Link>
    )
}

export default Cart